import { isNil, keys } from 'lodash';
// Import constants
import { ErrorShowType, l, MonthDayYearFormat, TimeFormatWithoutSeconds, DynamicInputTypes } from 'constants/common';
// Import Services
import { Helpers } from 'services';
// Import Enums
import { BonusCalculationTypesEnum } from 'enums';

const { customMoment } = Helpers;

const customFieldInputScenario = (value) => ({
    isValid: !!value || null,
    errorText: '',
    value: value || '',
    paramValue: '',
    type: ErrorShowType.Default,
    validationCredentials: [
        {
            ValidationType: 'required',
            ErrorMessage: l.CannotBeEmpty,
            ParametersValues: null,
        },
        {
            ValidationType: 'minLength',
            ErrorMessage: l.MustContainMinimumCharacters,
            ParametersValues: '3',
        },
        {
            ValidationType: 'maxLength',
            ErrorMessage: l.MustContainMaximumCharacters,
            ParametersValues: '300',
        },
    ],
});

const customFieldDropdownScenario = (value) => ({
    isValid: !!value || null,
    errorText: '',
    value: value || '',
    paramValue: '',
    type: ErrorShowType.Default,
    validationCredentials: [
        {
            ValidationType: 'required',
            ErrorMessage: l.CannotBeEmpty,
            ParametersValues: null,
        },
    ],
});

const ScheduleScenario = (schedule) => ({
    SchedulerStartDate: {
        isValid: null,
        value: {
            fromDate: customMoment(schedule.SchedulerStartDate).format(MonthDayYearFormat),
            fromTime: customMoment(schedule.SchedulerStartDate).format(TimeFormatWithoutSeconds),
            timeZone: schedule.TimeZone,
        },
        type: ErrorShowType.Default,
        errorText: '',
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'fromDateBiggerThanCurrentDate',
                ErrorMessage: l.StartDateMustBeBiggerThanCurrentDate,
                ParametersValues: 'false',
            },
            {
                ValidationType: 'dateCompareThanDate',
                ErrorMessage: l.StartDateMustBeSmallerThanEndDate,
                ParametersValues: 'false',
            },
        ],
    },
    SchedulerEndDate: {
        isValid: null,
        value: {
            fromDate: customMoment(schedule.SchedulerStartDate).format(MonthDayYearFormat),
            toDate: customMoment(schedule.SchedulerEndDate).format(MonthDayYearFormat),
            fromTime: customMoment(schedule.SchedulerStartDate).format(TimeFormatWithoutSeconds),
            timeZone: schedule.TimeZone,
        },
        type: ErrorShowType.Default,
        errorText: '',
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'toDateBiggerThanCurrentDate',
                ErrorMessage: l.EndDateMustBeBiggerThanCurrentDate,
                ParametersValues: 'false',
            },
            {
                ValidationType: 'dateCompareThanDate',
                ErrorMessage: l.EndDateMustBeBiggerThanStartDate,
                ParametersValues: 'false',
            },
        ],
    },
    SchedulerStartTime: {
        isValid: null,
        value: schedule.SchedulerStartDate.fromTime,
        type: ErrorShowType.Default,
        errorText: '',
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'startTimeValidation',
                ErrorMessage: l.InvalidTime,
            },
        ],
    },
});

const CollectAnalysisByDateScenario = (property) => ({
    CollectDate: {
        isValid: null,
        value: property.CollectDate,
        type: ErrorShowType.Default,
        errorText: '',
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'dateCompareThanDate',
                ErrorMessage: property.ErrorMessage,
                ParametersValues: 'false',
            },
        ],
    },
});

const campaignValidationScenario = (_data, _pageType) => ({
    Name: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.CannotBeEmpty,
                ParametersValues: null,
            },
            {
                ValidationType: 'firstSymbol',
                ErrorMessage: l.NameFirstCharacterCantBeASymbol,
                ParametersValues: /^[\p{L}0-9]/gu,
            },
            {
                ValidationType: 'minLength',
                ErrorMessage: l.MustContainMinimumCharacters,
                ParametersValues: '3',
            },
            {
                ValidationType: 'maxLength',
                ErrorMessage: l.MustContainMaximumCharacters,
                ParametersValues: '50',
            },
        ],
    },
    Description: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'maxLength',
                ErrorMessage: l.MustContainMaximumCharacters,
                ParametersValues: '250',
            },
        ],
    },
    ChosenSegment: {
        isValid: null,
        value: false,
        type: ErrorShowType.Toaster,
        errorText: '',
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.PleaseChooseSegment,
                ParametersValues: 'false',
            },
        ],
    },
    ChosenTemplate: {
        isValid: null,
        value: false,
        type: ErrorShowType.Toaster,
        errorText: '',
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.PleaseChooseTemplate,
                ParametersValues: 'false',
            },
        ],
    },
    ChosenBonus: {
        isValid: null,
        value: false,
        type: ErrorShowType.Toaster,
        errorText: '',
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.PleaseChooseBonus,
                ParametersValues: 'false',
            },
        ],
    },
});

const campaignValidationScenario2 = () => ({});

const staticBonusCalculationScenario = (minValue, maxValue, amount) => ({
    isValid: null,
    errorText: '',
    value: isNil(amount) ? '' : amount.toString(),
    paramValue: '',
    type: ErrorShowType.Default,
    validationCredentials: [
        {
            ValidationType: 'required',
            ErrorMessage: l.CannotBeEmpty,
            ParametersValues: null,
        },
        {
            ValidationType: 'greaterThanOrEqual',
            ErrorMessage: l.MustBeBiggerThan,
            ParametersValues: minValue,
        },
        {
            ValidationType: 'lessThanOrEqual',
            ErrorMessage: l.MustBeSmallerThan,
            ParametersValues: maxValue,
        },
        {
            ValidationType: 'greaterThan',
            ErrorMessage: l.MustBeBiggerThan,
            ParametersValues: 0,
        },
    ],
});

const dynamicBonusCalculationBonusKindScenarioProperties = (id, value, params) => {
    interface ValidationCredential {
        ValidationType: string;
        ErrorMessage: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ParametersValues: any;
    }

    const validationCredentials: ValidationCredential[] = [
        {
            ValidationType: 'required',
            ErrorMessage: l.CannotBeEmpty,
            ParametersValues: null,
        },
    ];

    if (id === 'percentage') {
        validationCredentials.push({
            ValidationType: 'greaterThan',
            ErrorMessage: l.MustBeGreaterThenZero,
            ParametersValues: 0,
        });
    }

    if (id === 'radioGroupValue' && !isNil(params.supportedCases)) {
        validationCredentials.push({
            ValidationType: 'isInRange',
            ErrorMessage: l.BonusCalculationRadioNotInRange,
            ParametersValues: { range: keys(params.supportedCases) },
        });
    }

    if (id === 'bonusKind' && !isNil(params.supportedCases)) {
        validationCredentials.push({
            ValidationType: 'isInRange',
            ErrorMessage: l.BonusKindNotInRange,
            ParametersValues: { range: params.supportedCases[params.values.radioGroupValue] },
        });
    }

    return {
        isValid: null,
        errorText: '',
        value: isNil(value) ? '' : value.toString(),
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: validationCredentials,
    };
};

const ExpirationValueScenario = (property) => ({
    expirationValue: {
        isValid: null,
        value: property,
        type: ErrorShowType.Default,
        errorText: '',
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'isDateBiggerThanCurrentDate',
                ErrorMessage: l.ExpirationDateIsInvalid,
                ParametersValues: null,
            },
            {
                ValidationType: 'isPositiveInteger',
                ErrorMessage: l.ExpirationPeriodIsInvalid,
                ParametersValues: null,
            },
        ],
    },
});

const ExpirationTypeScenario = (property) => ({
    expirationType: {
        isValid: null,
        value: property.expirationType,
        type: ErrorShowType.Default,
        errorText: l.ExpirationTypeCannotBeEmpty,
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.ExpirationTypeCannotBeEmpty,
                ParametersValues: null,
            },
        ],
    },
});

const BonusSelectedWalletScenario = (property) => ({
    selectedWallet: {
        isValid: true,
        value: property,
        type: ErrorShowType.Default,
        errorText: l.SelectedWalletIsNotValidForChosenBonus,
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'isSelectedWalletSupportedInBonus',
                ErrorMessage: l.SelectedWalletIsNotValidForChosenBonus,
                ParametersValues: null,
            },
        ],
    },
});

function bonusCalculationScenarioPropertiesCreator(data, editCloneMode = false) {
    if (!isNil(data?.info)) {
        const info = data.info;
        if (data.type === BonusCalculationTypesEnum.Static) {
            return keys(info).reduce((acc, id) => {
                acc[id + BonusCalculationTypesEnum.Static] = {
                    ...staticBonusCalculationScenario(
                        info[id]?.minValue,
                        info[id]?.maxValue,
                        isNil(data?.amounts) ? '' : data?.amounts[id],
                    ),
                };
                return acc;
            }, {});
        } else if (data.type === BonusCalculationTypesEnum.Dynamic) {
            return keys(info).reduce((acc, id) => {
                acc[id] = {
                    ...dynamicBonusCalculationBonusKindScenarioProperties(
                        id,
                        isNil(data?.values) ? '' : data?.values[id],
                        { ...data.params, values: data.values },
                    ),
                };
                return acc;
            }, {});
        }
    } else if (data.customField) {
        const { key, value, type } = data.property;
        return type === DynamicInputTypes.INPUT
            ? { [key]: customFieldInputScenario(value) }
            : { [key]: customFieldDropdownScenario(value) };
    } else if (data.schedule) {
        return ScheduleScenario(data.property);
    } else if (data.collectAnalysisByDate) {
        return CollectAnalysisByDateScenario(data.property);
    } else if (data.expirationValue) {
        return ExpirationValueScenario(data.property);
    } else if (data.expirationType) {
        return ExpirationTypeScenario(data.property);
    } else if (data.selectedWallet) {
        const { selectedWallet, amounts } = data.property;
        if (selectedWallet === null) {
            return BonusSelectedWalletScenario(data.property);
        }

        if (editCloneMode) {
            const amountsObj = amounts.reduce((acc, item) => {
                return { ...acc, ...item };
            }, {});

            return {
                ...BonusSelectedWalletScenario(data.property),
                isValid: !(selectedWallet in amountsObj),
            };
        }
        return BonusSelectedWalletScenario(data.property);
    }

    return null;
}

export { campaignValidationScenario, campaignValidationScenario2, bonusCalculationScenarioPropertiesCreator };
